import { render } from "./ContactPreview.vue?vue&type=template&id=18ea12fb&ts=true"
import script from "./ContactPreview.vue?vue&type=script&lang=ts"
export * from "./ContactPreview.vue?vue&type=script&lang=ts"

import "./ContactPreview.vue?vue&type=style&index=0&id=18ea12fb&lang=scss"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__